module.exports = __webpack_public_path__ + "img/pdf-icon-second.691fcda2.png";